export const works = [
  {
    id: "w01",
    title: "暮色丝绒",
    categoryId: "fashion",
    categoryName: "时尚大片",
    cover:
      "https://readdy.ai/api/search-image?query=fashion%20editorial%20portrait%20of%20a%20woman%20in%20deep%20velvet%20dress%2C%20golden%20hour%20dusk%20lighting%2C%20warm%20amber%20tones%2C%20soft%20beige%20studio%20backdrop%2C%20luxury%20magazine%20aesthetic%2C%20high%20detail&width=900&height=1200&seq=w01a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=fashion%20portrait%20of%20a%20woman%20in%20velvet%20gown%20turning%20in%20warm%20dusk%20light%2C%20cinematic%20amber%20tones%2C%20cream%20backdrop%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=1500&seq=w01b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=close%20up%20fashion%20beauty%20shot%20of%20a%20woman%20with%20elegant%20expression%2C%20warm%20gold%20lighting%2C%20soft%20neutral%20background%2C%20luxury%20magazine%20aesthetic%2C%20high%20detail&width=1200&height=1500&seq=w01c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=fashion%20editorial%20of%20a%20woman%20in%20velvet%20outfit%20in%20a%20warm%20minimal%20studio%2C%20soft%20amber%20light%2C%20beige%20tones%2C%20high%20detail%20photography&width=1200&height=1500&seq=w01d&orientation=landscape",
    ],
    author: "林晚",
    date: "2025-08-14",
    location: "上海 · 暖光影棚",
    tags: ["时尚", "丝绒", "暖色", "高定"],
    description:
      "这组作品以暮色时分的暖光为灵感，让丝绒的质感在柔和光线里层层晕开。模特的一次转身与一个回眸，被定格成介于温柔与力量之间的时尚叙事。",
    views: 18240,
    featured: true,
  },
  {
    id: "w02",
    title: "街头霓虹",
    categoryId: "fashion",
    categoryName: "时尚大片",
    cover:
      "https://readdy.ai/api/search-image?query=street%20style%20fashion%20portrait%20of%20a%20woman%20at%20night%20with%20warm%20neon%20shop%20lights%2C%20urban%20evening%20mood%2C%20orange%20and%20amber%20glow%2C%20high%20detail%20editorial%20photography&width=900&height=1200&seq=w02a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=night%20street%20fashion%20portrait%20of%20a%20woman%20walking%20under%20warm%20neon%20signs%2C%20urban%20city%20evening%2C%20orange%20ambient%20light%2C%20high%20detail&width=1200&height=1500&seq=w02b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=fashion%20detail%20shot%20of%20a%20woman%20with%20stylish%20outfit%20in%20warm%20street%20light%2C%20bokeh%20background%2C%20amber%20tones%2C%20high%20detail&width=1200&height=1500&seq=w02c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=urban%20fashion%20editorial%20of%20a%20woman%20in%20a%20warm%20lit%20city%20alley%20at%20night%2C%20orange%20glow%2C%20cinematic%20mood%2C%20high%20detail&width=1200&height=1500&seq=w02d&orientation=landscape",
    ],
    author: "苏芷",
    date: "2025-07-30",
    location: "成都 · 老街夜市",
    tags: ["时尚", "街拍", "霓虹", "夜景"],
    description:
      "夜晚的街道是最好的舞台。暖橙色的霓虹灯牌下，女性的率性与都市的烟火气交叠，构成一组有速度感、有情绪温度的街头时尚大片。",
    views: 15620,
    featured: true,
  },
  {
    id: "w03",
    title: "极简主义",
    categoryId: "fashion",
    categoryName: "时尚大片",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20fashion%20portrait%20of%20a%20woman%20in%20clean%20tailored%20outfit%2C%20simple%20cream%20studio%20background%2C%20soft%20even%20lighting%2C%20elegant%20understated%20editorial%2C%20high%20detail&width=900&height=1200&seq=w03a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=minimalist%20fashion%20portrait%20of%20a%20woman%20posed%20simply%2C%20neutral%20beige%20backdrop%2C%20soft%20shadow%2C%20elegant%20editorial%20photography%2C%20high%20detail&width=1200&height=1500&seq=w03b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=clean%20minimal%20fashion%20detail%20of%20a%20woman%20in%20tailored%20clothing%2C%20cream%20background%2C%20soft%20light%2C%20high%20detail&width=1200&height=1500&seq=w03c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=minimalist%20fashion%20editorial%20of%20a%20woman%20in%20a%20bright%20clean%20studio%2C%20neutral%20tones%2C%20high%20detail%20photography&width=1200&height=1500&seq=w03d&orientation=landscape",
    ],
    author: "陈屿",
    date: "2025-06-21",
    location: "杭州 · 白摄影棚",
    tags: ["时尚", "极简", "留白", "高级"],
    description:
      "去掉所有多余的装饰，只留下线条、光影与人。极简的构图反而让女性的姿态成为画面唯一的主角，干净、克制，却极有力量。",
    views: 12980,
    featured: false,
  },
  {
    id: "w04",
    title: "复古红唇",
    categoryId: "fashion",
    categoryName: "时尚大片",
    cover:
      "https://readdy.ai/api/search-image?query=retro%20glamour%20beauty%20portrait%20of%20a%20woman%20with%20classic%20red%20lipstick%2C%20vintage%20warm%20lighting%2C%20cream%20backdrop%2C%20old%20hollywood%20elegance%2C%20high%20detail&width=900&height=1200&seq=w04a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=vintage%20beauty%20close%20up%20of%20a%20woman%20with%20retro%20makeup%2C%20warm%20gold%20lighting%2C%20soft%20cream%20background%2C%20classic%20elegance%2C%20high%20detail&width=1200&height=1500&seq=w04b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=retro%20fashion%20portrait%20of%20a%20woman%20in%20elegant%20vintage%20outfit%2C%20warm%20studio%20light%2C%20neutral%20backdrop%2C%20high%20detail&width=1200&height=1500&seq=w04c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=vintage%20glamour%20editorial%20of%20a%20woman%20in%20a%20warm%20retro%20studio%2C%20golden%20light%2C%20elegant%20mood%2C%20high%20detail&width=1200&height=1500&seq=w04d&orientation=landscape",
    ],
    author: "林晚",
    date: "2025-05-09",
    location: "北京 · 复古影棚",
    tags: ["时尚", "复古", "红唇", "经典"],
    description:
      "一管正红口红、一道复古弧眉，就把我们带回旧时光的优雅。这组片子致敬经典好莱坞的华丽，却带着当代女性自己的笃定与从容。",
    views: 21050,
    featured: true,
  },
  {
    id: "w05",
    title: "柏林冬叙",
    categoryId: "fashion",
    categoryName: "时尚大片",
    cover:
      "https://readdy.ai/api/search-image?query=winter%20fashion%20portrait%20of%20a%20woman%20in%20a%20warm%20wool%20coat%2C%20muted%20soft%20light%2C%20minimal%20architectural%20background%2C%20warm%20beige%20palette%2C%20high%20detail%20editorial&width=900&height=1200&seq=w05a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=winter%20fashion%20editorial%20of%20a%20woman%20in%20a%20long%20coat%2C%20soft%20diffused%20light%2C%20neutral%20urban%20backdrop%2C%20warm%20tones%2C%20high%20detail&width=1200&height=1500&seq=w05b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=elegant%20winter%20portrait%20detail%20of%20a%20woman%2C%20cozy%20warm%20lighting%2C%20minimal%20background%2C%20high%20detail&width=1200&height=1500&seq=w05c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=winter%20fashion%20editorial%20of%20a%20woman%20in%20a%20warm%20minimal%20setting%2C%20soft%20beige%20tones%2C%20high%20detail%20photography&width=1200&height=1500&seq=w05d&orientation=landscape",
    ],
    author: "Marco",
    date: "2025-03-18",
    location: "柏林 · 城市街景",
    tags: ["时尚", "冬装", "简约", "建筑"],
    description:
      "大衣、冷光与几何感的建筑线条，是这组片子的关键词。寒意里的一点暖调，让冬日的女性显得格外沉静而有故事。",
    views: 9760,
    featured: false,
  },
  {
    id: "w06",
    title: "流动的身体",
    categoryId: "art",
    categoryName: "艺术摄影",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20fine%20art%20photograph%20of%20a%20woman%20body%20curves%20in%20motion%2C%20soft%20warm%20light%20and%20shadow%2C%20minimal%20cream%20background%2C%20poetic%20elegant%2C%20high%20detail&width=900&height=1200&seq=w06a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=abstract%20art%20photography%20of%20a%20woman%20silhouette%20in%20motion%2C%20soft%20dramatic%20light%2C%20cream%20backdrop%2C%20poetic%20composition%2C%20high%20detail&width=1200&height=1500&seq=w06b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=fine%20art%20light%20and%20shadow%20study%20of%20human%20form%2C%20warm%20minimal%20background%2C%20elegant%20abstract%2C%20high%20detail&width=1200&height=1500&seq=w06c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=fine%20art%20photograph%20of%20flowing%20human%20form%20in%20soft%20warm%20light%2C%20minimal%20studio%2C%20poetic%20mood%2C%20high%20detail&width=1200&height=1500&seq=w06d&orientation=landscape",
    ],
    author: "沈鹿",
    date: "2025-08-02",
    location: "广州 · 艺术工作室",
    tags: ["艺术", "形体", "光影", "抽象"],
    description:
      "身体本身就成为线条。慢速快门下的微小移动，让轮廓在光里变得像水一样流动，模糊了形体与抽象之间的界限。",
    views: 11340,
    featured: true,
  },
  {
    id: "w07",
    title: "光影几何",
    categoryId: "art",
    categoryName: "艺术摄影",
    cover:
      "https://readdy.ai/api/search-image?query=geometric%20light%20and%20shadow%20art%20photograph%20of%20a%20woman%2C%20sharp%20sunlight%20patterns%2C%20minimal%20warm%20background%2C%20architectural%20composition%2C%20high%20detail&width=900&height=1200&seq=w07a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=geometric%20shadow%20patterns%20on%20a%20woman%20face%2C%20dramatic%20warm%20light%2C%20minimal%20cream%20background%2C%20art%20photography%2C%20high%20detail&width=1200&height=1500&seq=w07b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=abstract%20geometric%20light%20composition%20with%20human%20figure%2C%20warm%20tones%2C%20minimal%20studio%2C%20high%20detail&width=1200&height=1500&seq=w07c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=architectural%20light%20and%20shadow%20art%20photograph%20of%20a%20woman%2C%20warm%20minimal%20setting%2C%20high%20detail&width=1200&height=1500&seq=w07d&orientation=landscape",
    ],
    author: "沈鹿",
    date: "2025-06-30",
    location: "广州 · 混凝土空间",
    tags: ["艺术", "几何", "光影", "构图"],
    description:
      "当阳光穿过窗棂，在面部与墙面投下规整的几何切分，人物便与空间一起构成一幅冷静又迷人的抽象画。",
    views: 8940,
    featured: false,
  },
  {
    id: "w08",
    title: "水与镜",
    categoryId: "art",
    categoryName: "艺术摄影",
    cover:
      "https://readdy.ai/api/search-image?query=artistic%20photograph%20of%20a%20woman%20reflected%20in%20still%20water%2C%20soft%20warm%20light%2C%20minimal%20neutral%20background%2C%20poetic%20reflection%2C%20high%20detail&width=900&height=1200&seq=w08a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=woman%20reflection%20in%20mirror%20like%20water%20surface%2C%20warm%20soft%20light%2C%20minimal%20cream%20background%2C%20art%20photography%2C%20high%20detail&width=1200&height=1500&seq=w08b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=artistic%20water%20reflection%20detail%20with%20human%20form%2C%20warm%20tones%2C%20minimal%20composition%2C%20high%20detail&width=1200&height=1500&seq=w08c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=poetic%20art%20photograph%20of%20a%20woman%20by%20still%20water%2C%20warm%20minimal%20light%2C%20high%20detail&width=1200&height=1500&seq=w08d&orientation=landscape",
    ],
    author: "周颂",
    date: "2025-04-25",
    location: "厦门 · 海边水池",
    tags: ["艺术", "倒影", "水", "诗意"],
    description:
      "水面是一面会呼吸的镜子。人物与倒影彼此凝视、彼此渗透，真实与虚幻在同一帧里温柔地重叠。",
    views: 10230,
    featured: false,
  },
  {
    id: "w09",
    title: "静默花园",
    categoryId: "art",
    categoryName: "艺术摄影",
    cover:
      "https://readdy.ai/api/search-image?query=artistic%20portrait%20of%20a%20woman%20among%20dried%20flowers%2C%20soft%20warm%20natural%20light%2C%20muted%20cream%20tones%2C%20serene%20fine%20art%20mood%2C%20high%20detail&width=900&height=1200&seq=w09a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=fine%20art%20photograph%20of%20a%20woman%20in%20a%20quiet%20dried%20flower%20garden%2C%20soft%20warm%20light%2C%20muted%20tones%2C%20high%20detail&width=1200&height=1500&seq=w09b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=artistic%20detail%20of%20flowers%20and%20a%20woman%20in%20soft%20warm%20light%2C%20minimal%20cream%20background%2C%20high%20detail&width=1200&height=1500&seq=w09c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=serene%20art%20photograph%20of%20a%20woman%20in%20a%20muted%20garden%2C%20warm%20soft%20light%2C%20high%20detail&width=1200&height=1500&seq=w09d&orientation=landscape",
    ],
    author: "顾朗",
    date: "2025-02-11",
    location: "南京 · 私家庭院",
    tags: ["艺术", "花艺", "静谧", "自然"],
    description:
      "干花、旧墙与柔光，构成了一个几乎静止的空间。女性的侧脸融进花园的静默里，安静得能听见时间流过的声音。",
    views: 7610,
    featured: false,
  },
  {
    id: "w10",
    title: "釉色肖像",
    categoryId: "art",
    categoryName: "艺术摄影",
    cover:
      "https://readdy.ai/api/search-image?query=ceramic%20glaze%20textured%20fine%20art%20portrait%20of%20a%20woman%2C%20warm%20palette%20of%20terracotta%20and%20cream%2C%20soft%20studio%20light%2C%20high%20detail%20art%20photography&width=900&height=1200&seq=w10a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=artistic%20portrait%20with%20ceramic%20textured%20backdrop%2C%20warm%20terracotta%20tones%2C%20soft%20light%2C%20high%20detail&width=1200&height=1500&seq=w10b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=fine%20art%20beauty%20detail%20of%20a%20woman%20with%20warm%20earthy%20tones%2C%20minimal%20studio%2C%20high%20detail&width=1200&height=1500&seq=w10c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=earthy%20tone%20art%20portrait%20of%20a%20woman%20in%20a%20warm%20textured%20studio%2C%20high%20detail&width=1200&height=1500&seq=w10d&orientation=landscape",
    ],
    author: "周颂",
    date: "2025-01-19",
    location: "景德镇 · 陶艺工作室",
    tags: ["艺术", "陶艺", "暖调", "肌理"],
    description:
      "灵感来自宋代陶瓷的釉色。赭红、米白与土黄交织成一组暖色肖像，光影在暖调里散发着温润的、可以被触摸的质感。",
    views: 6890,
    featured: false,
  },
  {
    id: "w11",
    title: "晨间仪式",
    categoryId: "life",
    categoryName: "生活写真",
    cover:
      "https://readdy.ai/api/search-image?query=candid%20lifestyle%20portrait%20of%20a%20woman%20in%20soft%20morning%20light%20drinking%20coffee%2C%20cozy%20warm%20interior%2C%20cream%20tones%2C%20authentic%20mood%2C%20high%20detail&width=900&height=1200&seq=w11a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=lifestyle%20photograph%20of%20a%20woman%20enjoying%20a%20quiet%20morning%2C%20warm%20window%20light%2C%20cozy%20cream%20interior%2C%20high%20detail&width=1200&height=1500&seq=w11b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=cozy%20morning%20lifestyle%20detail%2C%20warm%20light%20and%20soft%20textiles%2C%20cream%20tones%2C%20high%20detail&width=1200&height=1500&seq=w11c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=lifestyle%20photograph%20of%20a%20woman%20in%20a%20bright%20warm%20home%20in%20the%20morning%2C%20soft%20light%2C%20high%20detail&width=1200&height=1500&seq=w11d&orientation=landscape",
    ],
    author: "苏芷",
    date: "2025-08-20",
    location: "上海 · 公寓",
    tags: ["生活", "晨光", "居家", "温暖"],
    description:
      "一杯手冲咖啡、一缕斜进窗子的光，就是一天最温柔的仪式。没有摆拍，只有真实流露的松弛与自在。",
    views: 13420,
    featured: true,
  },
  {
    id: "w12",
    title: "午后书店",
    categoryId: "life",
    categoryName: "生活写真",
    cover:
      "https://readdy.ai/api/search-image?query=candid%20portrait%20of%20a%20woman%20reading%20in%20a%20cozy%20bookstore%2C%20warm%20afternoon%20light%2C%20soft%20cream%20tones%2C%20authentic%20mood%2C%20high%20detail&width=900&height=1200&seq=w12a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=lifestyle%20photograph%20of%20a%20woman%20among%20bookshelves%2C%20warm%20soft%20light%2C%20cozy%20bookstore%2C%20high%20detail&width=1200&height=1500&seq=w12b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=cozy%20bookstore%20detail%20with%20warm%20light%20and%20paper%20textures%2C%20high%20detail&width=1200&height=1500&seq=w12c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=lifestyle%20photograph%20of%20a%20woman%20in%20a%20warm%20sunlit%20bookstore%2C%20high%20detail&width=1200&height=1500&seq=w12d&orientation=landscape",
    ],
    author: "陈屿",
    date: "2025-07-12",
    location: "苏州 · 旧书店",
    tags: ["生活", "阅读", "午后", "文艺"],
    description:
      "午后的书店总有一种让人慢下来的魔力。翻页的手、垂下的发丝、落在书脊上的光，都是生活最动人的注脚。",
    views: 9180,
    featured: false,
  },
  {
    id: "w13",
    title: "海边日记",
    categoryId: "life",
    categoryName: "生活写真",
    cover:
      "https://readdy.ai/api/search-image?query=natural%20lifestyle%20portrait%20of%20a%20woman%20by%20the%20sea%2C%20warm%20golden%20sunset%20light%2C%20soft%20breeze%2C%20cream%20sandy%20tones%2C%20high%20detail&width=900&height=1200&seq=w13a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=woman%20walking%20on%20a%20beach%20in%20golden%20hour%2C%20warm%20soft%20light%2C%20high%20detail%20lifestyle&width=1200&height=1500&seq=w13b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=lifestyle%20beach%20detail%20with%20warm%20sunset%20light%20and%20soft%20textures%2C%20high%20detail&width=1200&height=1500&seq=w13c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=lifestyle%20photograph%20of%20a%20woman%20by%20the%20sea%20at%20sunset%2C%20warm%20golden%20tones%2C%20high%20detail&width=1200&height=1500&seq=w13d&orientation=landscape",
    ],
    author: "林晚",
    date: "2025-06-05",
    location: "青岛 · 海岸线",
    tags: ["生活", "海边", "日落", "自由"],
    description:
      "海风、裙摆与被夕阳染成金色的侧脸。这组日记式的照片，记录的是一个女孩与大海相处的一整个慵懒黄昏。",
    views: 14760,
    featured: false,
  },
  {
    id: "w14",
    title: "厨房的温度",
    categoryId: "life",
    categoryName: "生活写真",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20lifestyle%20portrait%20of%20a%20woman%20cooking%20in%20a%20cozy%20kitchen%2C%20soft%20warm%20light%2C%20cream%20and%20wood%20tones%2C%20authentic%20mood%2C%20high%20detail&width=900&height=1200&seq=w14a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=lifestyle%20photograph%20of%20a%20woman%20in%20a%20warm%20home%20kitchen%2C%20soft%20light%2C%20cozy%20wood%20tones%2C%20high%20detail&width=1200&height=1500&seq=w14b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=cozy%20kitchen%20detail%20with%20warm%20light%20and%20food%20textures%2C%20cream%20tones%2C%20high%20detail&width=1200&height=1500&seq=w14c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=warm%20lifestyle%20photograph%20of%20a%20woman%20cooking%20in%20a%20sunlit%20kitchen%2C%20high%20detail&width=1200&height=1500&seq=w14d&orientation=landscape",
    ],
    author: "顾朗",
    date: "2025-04-02",
    location: "长沙 · 家中厨房",
    tags: ["生活", "厨房", "烟火气", "日常"],
    description:
      "厨房里的光总是暖的。切菜的节奏、袅袅的热气、偶尔上扬的嘴角，把再普通不过的一餐做成了有温度的影像。",
    views: 8240,
    featured: false,
  },
  {
    id: "w15",
    title: "超现实梦境",
    categoryId: "creative",
    categoryName: "创意特辑",
    cover:
      "https://readdy.ai/api/search-image?query=surreal%20conceptual%20photograph%20of%20a%20woman%20in%20a%20dreamlike%20set%20with%20floating%20objects%2C%20vivid%20warm%20orange%20and%20gold%20palette%2C%20playful%20imagination%2C%20high%20detail%20art&width=900&height=1200&seq=w15a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=surreal%20conceptual%20portrait%20of%20a%20woman%20in%20a%20dreamlike%20colorful%20scene%2C%20warm%20vivid%20palette%2C%20high%20detail&width=1200&height=1500&seq=w15b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=creative%20surreal%20detail%20with%20playful%20set%20design%20and%20warm%20colors%2C%20high%20detail&width=1200&height=1500&seq=w15c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=surreal%20conceptual%20art%20photograph%20of%20a%20woman%20in%20a%20vivid%20warm%20dream%20set%2C%20high%20detail&width=1200&height=1500&seq=w15d&orientation=landscape",
    ],
    author: "Marco",
    date: "2025-09-01",
    location: "深圳 · 创意棚",
    tags: ["创意", "超现实", "色彩", "想象"],
    description:
      "如果把梦境拍下来会是什么样？漂浮的物件、错位的空间、大胆的暖色块，共同搭出一个只属于女性的超现实剧场。",
    views: 16890,
    featured: true,
  },
  {
    id: "w16",
    title: "色彩实验",
    categoryId: "creative",
    categoryName: "创意特辑",
    cover:
      "https://readdy.ai/api/search-image?query=bold%20color%20block%20creative%20portrait%20of%20a%20woman%2C%20vivid%20warm%20orange%20yellow%20and%20cream%20palette%2C%20graphic%20minimal%20set%2C%20high%20detail%20art&width=900&height=1200&seq=w16a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=color%20block%20creative%20portrait%20with%20bold%20warm%20palette%2C%20graphic%20set%20design%2C%20high%20detail&width=1200&height=1500&seq=w16b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=creative%20color%20experiment%20detail%20with%20bold%20shapes%2C%20warm%20tones%2C%20high%20detail&width=1200&height=1500&seq=w16c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=bold%20color%20creative%20editorial%20of%20a%20woman%2C%20vivid%20warm%20palette%2C%20high%20detail&width=1200&height=1500&seq=w16d&orientation=landscape",
    ],
    author: "顾朗",
    date: "2025-07-25",
    location: "上海 · 色彩实验室",
    tags: ["创意", "色块", "实验", "大胆"],
    description:
      "把女性肖像放进纯粹的色彩构成里，橙红、亮黄与米白互相碰撞。这是一次关于颜色情绪的实验，也是一次视觉的张狂发声。",
    views: 10970,
    featured: false,
  },
  {
    id: "w17",
    title: "镜像迷宫",
    categoryId: "creative",
    categoryName: "创意特辑",
    cover:
      "https://readdy.ai/api/search-image?query=creative%20mirror%20maze%20portrait%20of%20a%20woman%20with%20multiple%20reflections%2C%20warm%20ambient%20light%2C%20surreal%20art%20composition%2C%20high%20detail&width=900&height=1200&seq=w17a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=woman%20surrounded%20by%20mirrors%20with%20infinite%20reflections%2C%20warm%20light%2C%20creative%20composition%2C%20high%20detail&width=1200&height=1500&seq=w17b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=mirror%20maze%20creative%20detail%20with%20warm%20light%20and%20reflections%2C%20high%20detail&width=1200&height=1500&seq=w17c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=creative%20mirror%20maze%20art%20photograph%20of%20a%20woman%2C%20warm%20ambient%20light%2C%20high%20detail&width=1200&height=1500&seq=w17d&orientation=landscape",
    ],
    author: "沈鹿",
    date: "2025-05-28",
    location: "广州 · 镜面装置",
    tags: ["创意", "镜像", "装置", "迷幻"],
    description:
      "无数面镜子让一个人变成许多个。暖光在反射之间不断折射，安静的空间里却藏着强烈的自我对话与视觉迷醉。",
    views: 12230,
    featured: false,
  },
  {
    id: "w18",
    title: "纸与风",
    categoryId: "creative",
    categoryName: "创意特辑",
    cover:
      "https://readdy.ai/api/search-image?query=creative%20portrait%20of%20a%20woman%20with%20flowing%20paper%20sculptures%20in%20the%20air%2C%20warm%20soft%20light%2C%20minimal%20cream%20background%2C%20high%20detail%20art&width=900&height=1200&seq=w18a&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=creative%20photograph%20of%20flowing%20paper%20shapes%20around%20a%20woman%2C%20warm%20light%2C%20minimal%20background%2C%20high%20detail&width=1200&height=1500&seq=w18b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=paper%20sculpture%20creative%20detail%20with%20warm%20soft%20light%2C%20cream%20tones%2C%20high%20detail&width=1200&height=1500&seq=w18c&orientation=portrait",
      "https://readdy.ai/api/search-image?query=creative%20art%20photograph%20of%20a%20woman%20with%20flowing%20paper%20forms%2C%20warm%20minimal%20set%2C%20high%20detail&width=1200&height=1500&seq=w18d&orientation=landscape",
    ],
    author: "苏芷",
    date: "2025-03-30",
    location: "成都 · 纸艺工作坊",
    tags: ["创意", "纸艺", "轻盈", "流动"],
    description:
      "轻薄的纸在风里舒展、翻卷，与女性的姿态形成奇妙的呼应。整组作品轻盈、通透，却在留白处装满呼吸感。",
    views: 8390,
    featured: false,
  },
];